/**
 * 合同预警（延伸需求 3.4）
 *
 * 页面本体在 `components/AlertBoard.tsx`——合同与费用的预警形状完全一样，
 * 差别只有数据源与权限码。抄两份的代价是**处理规则会分叉**。
 */

import { Card } from 'antd';
import {
  ContractAlertType,
  CONTRACT_ALERT_TYPE_LABELS,
  PermissionCode,
} from '@ilc/shared';
import { contractApi } from '@/api/endpoints';
import { AlertBoard } from '@/components/AlertBoard';

export function ContractAlertsPage(): React.ReactElement {
  return (
    <AlertBoard
      title="合同预警"
      description="每日自动扫描合同执行情况；临近到期这类按天变化的预警每天至多一条"
      alerts={(q) => contractApi.alerts(q)}
      handle={(id, body) => contractApi.handleAlert(id, body)}
      handlePermission={PermissionCode.CONTRACT_ALERT_HANDLE}
      typeOptions={Object.entries(CONTRACT_ALERT_TYPE_LABELS).map(([value, label]) => ({
        value,
        label,
      }))}
      footnote={
        <>
          <p style={{ marginTop: 0 }}>
            八类预警的判据（由后端每日扫描算出，界面上看到的每一条都能对上其中一条）：
          </p>
          <ul style={{ margin: 0, paddingLeft: 18, fontSize: 13 }}>
            <li>
              <strong>超开票</strong>：已开票金额 &gt; 合同金额。发票<em>开出即占用额度</em>，与它在本平台走到哪一步无关。
            </li>
            <li>
              <strong>超付款</strong>：已付款（只算状态为「已付款」的记录）&gt; 合同金额。
            </li>
            <li>
              <strong>临近到期</strong>：距工期届满不足 30 天。<em>按天分桶</em>——今天处理掉今天那条，明天若仍未到期还会再提醒。
            </li>
            <li>
              <strong>质保金到期</strong>：质保期届满前 30 天内。
            </li>
            <li>
              <strong>结算阶段超比例</strong>：某阶段已付 &gt; 该阶段上限（有比例按「比例 × 合同金额」，否则按约定金额）。
            </li>
            <li>
              <strong>长期未开票</strong>：签订超过 90 天且一张票都没开过。
            </li>
            <li>
              <strong>未关联上级合同</strong>：非总包合同但没有挂上级。
              这条多半来自一期留下的历史数据——<em>迁移时刻意没有回填</em>（编一个不存在的总包合同就是假数据），
              所以用预警把缺口暴露出来让人补，而不是让它静默。
            </li>
            <li>
              <strong>供应商异常</strong>：取最近一次企查查核验的经营状态（注销/吊销/停业/经营异常）。
              <em>取不到就不报</em>——「不知道」既不能报成正常（静默放行），也不能报成异常（虚构风险）。
            </li>
          </ul>
          <Card size="small" style={{ marginTop: 12, background: '#fafafa' }}>
            扫描每 6 小时一轮，但写入按 <code>dedup_key</code> 幂等：
            同一件长期成立的事（如超开票）只产生一条；按天变化的事每天至多一条。
            <strong>只有真的新建了才发通知</strong>，不会每天把同一件事再推一遍。
          </Card>
        </>
      }
    />
  );
}

export default ContractAlertsPage;
